import { NgClass } from '@angular/common';
import { Component, HostListener, Input, output } from '@angular/core';
import { RouterLink } from '@angular/router';

import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

import { Size } from '@bn/primitives';

import { ButtonComponent } from '../button/button.component';
import { ItemStyle } from '../button/models';
import { ModalState } from '../dialog/models/modal-state.model';
import { DropdownMenuComponent } from '../dropdown-menu/dropdown-menu.component';
import { DropdownMenuItem } from '../dropdown-menu/models/dropdown-menu-item.model';

@Component({
  selector: 'bn-web-ui-button-dropdown',
  templateUrl: './button-dropdown.component.html',
  styleUrls: ['./button-dropdown.component.scss'],
  imports: [NgClass, ButtonComponent, DropdownMenuComponent, RouterLink, FaIconComponent],
})
export class ButtonDropdownComponent {
  @Input()
  public itemStyle?: ItemStyle;

  @Input()
  public leftIcon?: IconProp;

  @Input()
  public rightIcon?: IconProp;

  @Input()
  public fullWidth = false;

  @Input()
  public size?: Extract<Size, 'sm' | 'md' | 'lg' | 'xl' | 'xxl'> = 'md';

  @Input()
  public disabled = false;

  @Input()
  public lessPadding? = false;

  @Input()
  public noEllipsis? = false;

  @Input()
  public loading = false;

  @Input()
  public active = false;

  @Input()
  public dropdownItems: DropdownMenuItem[] = [];

  @Input()
  public routerLink?: string;

  @Input()
  public uploadData?: ModalState;

  @Input()
  dropdownSize?: Size;

  @HostListener('buttonAction', ['$event'])
  public onClick(event: Event | null): void {
    if (this.disabled || this.loading) {
      event?.preventDefault();
      event?.stopImmediatePropagation();
    }
  }

  public readonly buttonAction = output<null>();

  public readonly dropdownAction = output<DropdownMenuItem>();

  public onDropdownAction(menuItem: DropdownMenuItem): void {
    this.dropdownAction.emit(menuItem);
  }

  public onButtonAction(): void {
    this.buttonAction.emit(null);
  }
}
